import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("cinelut_token"));
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      localStorage.removeItem("cinelut_token");
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (token) await fetchMe();
      setLoading(false);
    })();
  }, [token, fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cinelut_token", data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    localStorage.setItem("cinelut_token", data.access_token);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("cinelut_token");
    setToken(null);
    setUser(null);
  };

  // Optimistically patch the local user (e.g. after credits change). Pass a
  // partial object: setUserPatch({ ai_credits: 50 })
  const setUserPatch = useCallback((patch) => {
    setUser((prev) => (prev ? { ...prev, ...patch } : prev));
  }, []);

  return (
    <AuthCtx.Provider value={{ user, token, loading, login, signup, logout, refreshMe: fetchMe, setUserPatch }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
